module.exports = __webpack_public_path__ + "img/сhatbots.e2713999.jpeg";